import { render, staticRenderFns } from "./signDialog.vue?vue&type=template&id=3df20cc6&scoped=true"
import script from "./signDialog.vue?vue&type=script&lang=js"
export * from "./signDialog.vue?vue&type=script&lang=js"
import style0 from "./signDialog.vue?vue&type=style&index=0&id=3df20cc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df20cc6",
  null
  
)

export default component.exports